import { useCallback, useEffect, useRef, useState } from 'react';
import { StyledContainer } from './Container.styled';
import { StyledImg } from './Img.styled';
import { StyledText } from './Text.styled';

interface ISettingVehicleRotationProps {
	onChange?: (newValue: number) => void;
}

const SettingVehicleRotation: React.FC<ISettingVehicleRotationProps> = ({
	onChange,
}) => {
	const [isRotating, setIsRotationg] = useState(false);
	const [rotationAngle, setRotationAngle] = useState(0);

	const imageRef = useRef<HTMLImageElement>(null);

	const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		setIsRotationg(true);
		e.preventDefault();
	};

	const handleMouseMove = (e: MouseEvent) => {
		if (isRotating && imageRef.current) {
			const rect = imageRef.current.getBoundingClientRect();
			const centerX = rect.left + rect.width / 2;
			const centerY = rect.top + rect.height / 2;

			const deltaX = centerX - e.clientX;
			const deltaY = centerY - e.clientY;

			let angle = (Math.atan2(deltaY, deltaX) * (180 / Math.PI) + 90) % 360;
			angle = angle < 0 ? angle + 360 : angle;

			const newValue = Math.trunc(angle);
			imageRef.current.style.transform = `scale(0.75) rotate(${newValue}deg)`;

			setRotationAngle(newValue);
			onChange?.(newValue);
		}
	};

	const handleMouseUp = () => setIsRotationg(false);

	useEffect(() => {
		if (isRotating) {
			window.addEventListener('mousemove', handleMouseMove);
			window.addEventListener('mouseup', handleMouseUp);
		} else {
			window.removeEventListener('mousemove', handleMouseMove);
			window.removeEventListener('mouseup', handleMouseUp);
		}

		return () => {
			window.removeEventListener('mousemove', handleMouseMove);
			window.removeEventListener('mouseup', handleMouseUp);
		};
	}, [isRotating]);

	const handleMouseWheel = useCallback(
		(e: React.WheelEvent<HTMLDivElement>) => {
			if (isRotating || !imageRef.current) {
				return;
			}

			const deltaDirection = e.deltaY < 0 ? 1 : -1;
			let angle = (rotationAngle + deltaDirection) % 360;
			angle = angle < 0 ? angle + 360 : angle;

			imageRef.current.style.transform = `scale(0.75) rotate(${angle}deg)`;

			setRotationAngle(angle);
			onChange?.(angle);
		},
		[isRotating, rotationAngle],
	);

	return (
		<StyledContainer onMouseDown={handleMouseDown} onWheel={handleMouseWheel}>
			<StyledImg ref={imageRef} />
			<StyledText>{rotationAngle}°</StyledText>
		</StyledContainer>
	);
};

export { SettingVehicleRotation };
